/** Tabs — a row of mutually-exclusive view switches. Caller owns the active state. */
export function Tabs({ tabs, activeId, onChange }) {
  const nav = document.createElement("div");
  nav.className = "tabs";
  nav.setAttribute("role", "tablist");

  for (const tab of tabs) {
    const btn = document.createElement("button");
    btn.className = "tab" + (tab.id === activeId ? " tab-active" : "");
    btn.dataset.tabId = tab.id;
    btn.textContent = tab.label;
    btn.setAttribute("role", "tab");
    btn.setAttribute("aria-selected", String(tab.id === activeId));
    btn.addEventListener("click", () => onChange(tab.id));
    nav.append(btn);
  }

  return nav;
}
